module.exports = __webpack_public_path__ + "static/media/logo-github.e090d856.jpg";